import type { ProxyEnv } from './const';
import { isInternalDomain } from './const';

/**
 * 扩展环境类型，包含本地开发环境
 */
export type CliEnv = ProxyEnv | 'local';

/**
 * CLI 安装脚本 URL 映射
 */
export const cliInstallScriptUrlMap: Record<CliEnv, string> = {
  prod: 'https://codeflicker.corp.kuaishou.com/install-cf.sh',
  pre: 'https://pre-kinsight.corp.kuaishou.com/install-cf.sh',
  test: 'https://qa-kinsight.staging.kuaishou.com/install-cf.sh',
  idc: 'https://kinsight.corp.kuaishou.com/install-cf.sh',
  local: 'http://localhost:30011/install-cf.sh',
};

/**
 * 获取当前环境
 * @returns 环境标识
 */
export const getCurrentEnv = (): CliEnv => {
  const hostname = window.location.hostname;

  // 根据域名判断环境
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'local'; // 本地开发环境
  }

  if (hostname.includes('pre-kinsight')) {
    return 'pre';
  }

  if (hostname.includes('qa-kinsight') || hostname.includes('staging')) {
    return 'test';
  }

  if (hostname.includes('kinsight.corp')) {
    return 'idc';
  }

  // 默认为生产环境
  return 'prod';
};

/**
 * 获取 CLI 安装脚本 URL
 * @returns 安装脚本的完整 URL
 */
export const getCliInstallScriptUrl = (): string => {
  const env = getCurrentEnv();
  return cliInstallScriptUrlMap[env];
};

/**
 * 获取 CLI 安装命令
 * @returns bash 安装命令
 */
export const getCliInstallCommand = (): string => {
  // 对外域名使用固定的安装脚本
  if (!isInternalDomain()) {
    return 'curl -fsSL https://codeflicker.ai/install.sh | bash';
  }

  // 对内域名根据环境获取对应的安装脚本
  const scriptUrl = getCliInstallScriptUrl();
  return `curl -fsSL ${scriptUrl} | bash`;
};
